var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.64942V11.3287C16 11.6968 15.7015 11.9951 15.3333 11.9951H14C13.6318 11.9951 13.3333 11.6968 13.3333 11.3287V10.9689C13.3011 9.63102 12.5315 8.42063 11.3333 7.82349C11.0933 7.69021 10.88 7.53028 10.6667 7.38367V19.3788C10.4398 22.1102 8.07004 24.1592 5.33333 23.9903C2.57741 24.1581 0.199411 22.0782 0 19.3255C0.199411 16.5728 2.57741 14.4929 5.33333 14.6607C6.26208 14.6588 7.17733 14.8829 8 15.3138V0.666396C8 0.298356 8.29848 0 8.66667 0H10C10.3682 0 10.6667 0.298356 10.6667 0.666396V0.892971C10.6388 2.24255 11.3772 3.49171 12.5733 4.11833C14.6762 5.15913 16.0049 7.30381 16 9.64942Z",
    fill: "#C0CBDE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.c97772245d40a671b57f3a552344ac1e.svg";
export { ForwardRef as ReactComponent };